/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import env from '../../../env';
import { Button, ErrorMessage } from '../../../components';
import { CartSummary } from '../cartSummary/summary';
import { useForm, fb, validators } from '../../../form';
import { address } from '../cartShipping/shippingFormData';
import utils from '../../../utils';

/**
 * Your Details step for Dartfish checkout. Collects full billing information
 * plus a required Club / Organisation field (sent as specialRequest).
 */
export function DartfishContact({ cart, saveShipping, post, cartId: cartIdProp }) {
  const data = cart?.billingAddress || cart?.shippingAddress || {};
  const model = React.useMemo(() => fb.group({
    billingInfo: address(data),
    club: [data.club || '', [validators.Required()], { type: 'text', label: 'Club / Organisation', placeholder: 'Your club or organisation name' }],
  }), []);
  const form = useForm(model, { usePlaceholder: true });
  const billingInfo = model.find('billingInfo');
  const renderBilling = (name) => form.renderControl(name, billingInfo);
  const render = (name) => form.renderControl(name);
  const cartId = cartIdProp ?? env.getDevCartId();

  const next = (e) => {
    form.validateForm(e, () => {
      const val = form.getValue();
      saveShipping({
        cartId,
        shippingMethod: 'Pickup',
        useSameAddress: true,
        shippingCountry: 'Australia',
        billingInfo: val.billingInfo || {},
        shippingInfo: null,
        specialRequest: val.club || '',
      });
      utils.ui.scrollTo('#ecmcart');
    });
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-9">
          <form>
            <h3>Your details</h3>
            <p className="text-muted">Please enter your details before payment. Once payment is complete, the Dartfish team will be in touch with you.</p>
            <h4 style={{ marginTop: '1rem' }}>Billing address</h4>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="form-group">{renderBilling('firstName')}</div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">{renderBilling('surname')}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">{renderBilling('street1')}</div>
                <div className="form-group">{renderBilling('street2')}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="form-group">{renderBilling('suburb')}</div>
              </div>
              <div className="col-12 col-md-4">
                <div className="form-group">{renderBilling('state')}</div>
              </div>
              <div className="col-12 col-md-4">
                <div className="form-group">{renderBilling('postcode')}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="form-group">{renderBilling('email')}</div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">{renderBilling('mobile')}</div>
              </div>
            </div>
            <div className="row" style={{ marginTop: '1rem' }}>
              <div className="col-12">
                <div className="form-group">{render('club')}</div>
              </div>
            </div>
          </form>
          <div className="form__actions" style={{ marginTop: '1rem' }}>
            <Button onClick={next} status={form.status}>Next</Button>
            <ErrorMessage errors={form.errors} summaryMessage="Please review the errors." />
            <ErrorMessage errors={post.errors} />
          </div>
        </div>
        <div className="col-md-3">
          <CartSummary cart={cart} />
        </div>
      </div>
    </div>
  );
}
